import React from 'react';

const LoggedInUserContext = React.createContext();

export default LoggedInUserContext;
